export default __webpack_public_path__ + "images/38b0cfd1c02bd569f5fdbb215c0c9ec6-philadelphia_desktop.webp";